<template>
  <b-modal
    id="coePublishedResultModal"
    :title="modalTitle"
    hide-footer
    centered
    size="xl"
  >
    <!-- Error message -->
    <div
      v-if="errorMessage"
      class="text-danger small mb-2"
    >
      {{ errorMessage }}
    </div>

    <!-- Loading -->
    <div v-if="loading" class="loading">
      <load-data></load-data>
    </div>

    <!-- No results -->
    <div
      v-else-if="!studentsResult.length"
      class="text-muted small py-2"
    >
      No published results available.
    </div>

    <!-- Student results -->
    <template v-else>
      <div
        v-for="(student, studentIndex) in studentsResult"
        :key="student.institution_user_id"
        class="mb-4"
      >
        <!-- Student Details -->
        <div class="font-weight-bold mb-2">
          <div>
            {{ studentIndex + 1 }}.
            {{ student.first_name || "" }}
            {{ student.last_name || "" }}
          </div>

          <!-- Register Number -->
          <div class="font-weight-normal text-muted small">
            Register Number: {{ student.register_no || "—" }}
          </div>
        </div>

        <!-- Student Result Table -->
        <table class="table table-striped table-bordered">
          <thead class="thead-dark">
            <tr>
              <th style="width: 70px;">Sl No</th>
              <th style="width: 140px;">Course Code</th>
              <th>Course Name</th>
              <th style="width: 140px;">Mark/Grade</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(course, courseIndex) in student.courses"
              :key="student.institution_user_id + '-' + course.course_id"
            >
              <td>{{ courseIndex + 1 }}</td>

              <!-- Course Code -->
              <td>
                {{ course.course_code || "—" }}
              </td>

              <!-- Course Name -->
              <td>
                {{ course.course_name || "—" }}
              </td>

              <!-- Mark / Grade -->
              <td>
                {{ course.mark_or_grade || "—" }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "CoePublishedResult",

  data() {
    return {
        exam:[],
      modalTitle: "",
      examId: null,
      studentsResult: [],
      loading: false,
      errorMessage: "",
    };
  },

  methods: {
    /**
     * Open the published result modal and load the results.
     */
    async open(exam) {
      this.modalTitle = `${exam.exam_name} - Published Result`;
      this.examId = exam.id;
      this.exam = exam;
      this.studentsResult = [];
      this.errorMessage = "";

      this.$bvModal.show("coePublishedResultModal");

      this.loading = true;

      try {
        const mainAPI = this.$store.getters.getAPIKey.mainAPI;

        const response = await this.$axios.get(
          `${mainAPI}/end-sem-exams/${exam.id}/${exam.course_group_id}/published-result`
        );

        this.studentsResult = response.data.data || [];
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Failed to load published results.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>